import { Person, Media } from '@/payload/payload-types';
import { SquareImageWithLabel } from '@/app/_components/SquareImageWithLabel';
import { ResimdoContactInfo } from '@/app/_components/ResimdoContactInfo';
import classes from './Department.module.scss';

export type TeamDepartment = NonNullable<Person['department']>;

interface DepartmentProps {
  team: Person[];
  firstModule?: boolean;
  showContactInfo?: boolean;
  contactHeading?: string;
}

export const Department: React.FC<DepartmentProps> = ({ team, firstModule, showContactInfo, contactHeading }) => {
  return (
    <div>
      {showContactInfo && contactHeading && (
        <span className={`${classes.contactHeading} heading-h2`}>{contactHeading}</span>
      )}
      <div className={[classes.departmentWrapper, firstModule && classes.firstModule].filter(Boolean).join(' ')}>
        {team && team.length > 0 &&
          team.map((person) => (
            <div key={person.id}>
              <SquareImageWithLabel
                image={person.image as Media}
                label={`${person.nickname || person.firstName}`}
              />
            </div>
          ))
        }
        {showContactInfo && (
          <div className={classes.contactInfo}>
            <ResimdoContactInfo title="" />
          </div>
        )}
      </div>
    </div>
  );
};
